// Lib
import React from 'react';

// Components
import Feather from '../../../../Feather';
import Button from '../../../../Button';

// Hooks
import useModal from '../../../../../hooks/useModal';

// Styles
import { useStyles } from './OrderProcessingInfoCardStyles';

const OrderProcessingInfoCard = ({ children }) => {
  const { classes } = useStyles();
  const { onClose } = useModal();

  return (
    <div className={classes.container}>
      <div className={classes.info}>
        <Feather nativeColor type="warning" className={classes.warningIcon} />
        Info
      </div>
      {children}
      <div className={classes.buttonContainer}>
        <div className={classes.fade}></div>
        <div className={classes.buttonBackground}>
          <Button onClick={onClose} className={classes.closeBtn}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderProcessingInfoCard;
